<template>
    <div class="page-wrapper">
        <h3 class="tit">E+工厂</h3>
        <div class="top-btns">
            <el-button class="r-btn" type="primary" icon="el-icon-edit" size="medium" @click="editHandle" :disabled="!uneditable">编辑表单</el-button>
            <br>
            <el-button class="r-btn" type="success" icon="el-icon-link" size="medium" @click="linkToDataV">查看大屏</el-button>
            <br>
            <el-button class="r-btn" type="warning" icon="el-icon-circle-check" size="medium" @click="takeEffectAtOnce">立即生效</el-button>
            <br>
            <el-button class="r-btn" type="info" icon="el-icon-top" size="medium" @click="toPageTop">回到顶部</el-button>
        </div>
        
        <div class="datav-form-wrapper">
            <el-form class="c-form" :model="editForm" ref="editForm" label-position="top">
                <el-form-item class="c-form-item" label="工厂人数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/001.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/001.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        工厂人数 = 最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="人数范围" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="factoryStaffNumer.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.factoryStaffNumer.min=switchToInt(editForm.factoryStaffNumer.min, 'unsigned'); switchObjMaxAndMin(editForm.factoryStaffNumer)"
                                    v-model="editForm.factoryStaffNumer.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>    
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="factoryStaffNumer.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.factoryStaffNumer.max=switchToInt(editForm.factoryStaffNumer.max, 'unsigned'); switchObjMaxAndMin(editForm.factoryStaffNumer)"
                                    v-model="editForm.factoryStaffNumer.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="出勤人数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/002.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/002.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        出勤人数 = 最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="人数范围" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="attendanceStaffNumber.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.attendanceStaffNumber.min=switchToInt(editForm.attendanceStaffNumber.min, 'unsigned'); switchObjMaxAndMin(editForm.attendanceStaffNumber)"
                                    v-model="editForm.attendanceStaffNumber.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="attendanceStaffNumber.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.attendanceStaffNumber.max=switchToInt(editForm.attendanceStaffNumber.max, 'unsigned'); switchObjMaxAndMin(editForm.attendanceStaffNumber)"
                                    v-model="editForm.attendanceStaffNumber.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="工厂面积">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/003.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/003.png">
                        </div>
                    </el-popover>
                    <el-form-item class="c-form-item-inner" label="工厂面积"
                        prop="factoryArea.radix"
                        :rules="[
                            { required: true, message: '请输入工厂面积（整数）', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.factoryArea.radix=switchToInt(editForm.factoryArea.radix,'unsigned')"
                            class="w"
                            v-model="editForm.factoryArea.radix"
                            placeholder="请输入工厂面积"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="设备数量">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/004.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/004.png">
                        </div>
                    </el-popover>
                    <el-form-item class="c-form-item-inner" label="设备数量"
                        prop="equipmentNumber.radix"
                        :rules="[
                            { required: true, message: '请输入设备数量（整数）', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.equipmentNumber.radix=switchToInt(editForm.equipmentNumber.radix, 'unsigned')"
                            class="w"
                            v-model="editForm.equipmentNumber.radix"
                            placeholder="请输入设备数量"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="工厂数量">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/005.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/005.png">
                        </div>
                    </el-popover>
                    <el-form-item class="c-form-item-inner" label="工厂数量"
                        prop="factoryNumber.radix"
                        :rules="[
                            { required: true, message: '请输入工厂数量（整数）', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.factoryNumber.radix=switchToInt(editForm.factoryNumber.radix, 'unsigned')"
                            class="w"
                            v-model="editForm.factoryNumber.radix"
                            placeholder="请输入工厂数量"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="工厂明细">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/006.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/006.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        根据最新清单更新，企业名称+配置数据(整数)
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.factoryDetails" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="10">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'factoryDetails.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入企业名称', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入企业名称" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">企业名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'factoryDetails.' + index + '.radix'"
                                    :rules="[
                                        { required: true, message: '请输入配置数据（整数）', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入配置数据" v-model="item.radix" :disabled="uneditable"
                                        @blur="item.radix=switchToInt(item.radix, 'unsigned')"
                                    >
                                        <template slot="prepend">配置数据</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.factoryDetails.length === 1}" 
                                    :title="editForm.factoryDetails.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('factoryDetails', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('factoryDetails', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="今日成衣加工件数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/007.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/007.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        今日成衣加工件数 = 最小值到最大值按时间有规律变化
                    </p>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="起始时间（小时， 0-24）"
                                prop="todayClothesProcessing.startTime"
                                :rules="[
                                    { required: true, message: '请输入起始时间', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.todayClothesProcessing.startTime=switchToInt(editForm.todayClothesProcessing.startTime, 'unsigned');switchObjMaxAndMin(editForm.todayClothesProcessing, 'startTime', 'endTime')"
                                    v-model="editForm.todayClothesProcessing.startTime"
                                    placeholder="请输入起始时间"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="结束时间（小时，0-24）"
                                prop="todayClothesProcessing.endTime"
                                :rules="[
                                    { required: true, message: '请输入结束时间', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.todayClothesProcessing.endTime=switchToInt(editForm.todayClothesProcessing.endTime, 'unsigned');switchObjMaxAndMin(editForm.todayClothesProcessing, 'startTime', 'endTime')"
                                    v-model="editForm.todayClothesProcessing.endTime"
                                    placeholder="请输入结束时间"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="全天最小值（件数）"
                                prop="todayClothesProcessing.min"
                                :rules="[
                                    { required: true, message: '请输入全天最小值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.todayClothesProcessing.min=switchToInt(editForm.todayClothesProcessing.min, 'unsigned');switchObjMaxAndMin(editForm.todayClothesProcessing)"
                                    v-model="editForm.todayClothesProcessing.min"
                                    placeholder="请输入全天最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="全天最大值（件数）"
                                prop="todayClothesProcessing.max"
                                :rules="[
                                    { required: true, message: '请输入全天最大值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.todayClothesProcessing.max=switchToInt(editForm.todayClothesProcessing.max, 'unsigned');switchObjMaxAndMin(editForm.todayClothesProcessing)"
                                    v-model="editForm.todayClothesProcessing.max"
                                    placeholder="请输入全天最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item class="c-form-item" label="今日完成订单数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/008.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/008.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        今日完成订单数 = 最小值到最大值按时间有规律变化
                    </p>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="起始时间（小时， 0-24）"
                                prop="todayFinishedOrder.startTime"
                                :rules="[
                                    { required: true, message: '请输入起始时间', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.todayFinishedOrder.startTime=switchToInt(editForm.todayFinishedOrder.startTime, 'unsigned');switchObjMaxAndMin(editForm.todayFinishedOrder, 'startTime', 'endTime')"
                                    v-model="editForm.todayFinishedOrder.startTime"
                                    placeholder="请输入起始时间"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="结束时间（小时，0-24）"
                                prop="todayFinishedOrder.endTime"
                                :rules="[
                                    { required: true, message: '请输入结束时间', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.todayFinishedOrder.endTime=switchToInt(editForm.todayFinishedOrder.endTime, 'unsigned');switchObjMaxAndMin(editForm.todayFinishedOrder, 'startTime', 'endTime')"
                                    v-model="editForm.todayFinishedOrder.endTime"
                                    placeholder="请输入结束时间"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="全天最小值（件数）"
                                prop="todayFinishedOrder.min"
                                :rules="[
                                    { required: true, message: '请输入全天最小值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.todayFinishedOrder.min=switchToInt(editForm.todayFinishedOrder.min, 'unsigned');switchObjMaxAndMin(editForm.todayFinishedOrder)"
                                    v-model="editForm.todayFinishedOrder.min"
                                    placeholder="请输入全天最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="全天最大值（件数）"
                                prop="todayFinishedOrder.max"
                                :rules="[
                                    { required: true, message: '请输入全天最大值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.todayFinishedOrder.max=switchToInt(editForm.todayFinishedOrder.max, 'unsigned');switchObjMaxAndMin(editForm.todayFinishedOrder)"
                                    v-model="editForm.todayFinishedOrder.max"
                                    placeholder="请输入全天最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>
 
                <el-form-item class="c-form-item" label="综合体订单覆盖率">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/009.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/009.png">
                        </div>
                    </el-popover>
                    <el-form-item class="c-form-item-inner" label="配置数据（小数，例如0.37）"
                        prop="zhtOrdercoverageRate.radix"
                        :rules="[
                            { required: true, message: '请输入配置数据', trigger: 'blur'}
                        ]"
                    >
                        <el-input
                            @blur="editForm.zhtOrdercoverageRate.radix=switchToFloat(editForm.zhtOrdercoverageRate.radix, 'unsigned')"
                            class="w"
                            v-model="editForm.zhtOrdercoverageRate.radix"
                            placeholder="请输入配置数据"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="合格率">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/010.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/010.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       各工序的合格率（%） = 最小值（整数）和最大值（整数）之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.passRate" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'passRate.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入工序名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">工序名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'passRate.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值（整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min=switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.passRate, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'passRate.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值（整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max=switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.passRate, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.passRate.length === 1}" 
                                    :title="editForm.passRate.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('passRate', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('passRate', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="工序占比">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/011.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/011.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        各项数值，为最小值和最大值之间的随机数
                    </p>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item class="c-form-item-inner" label="裁剪（小数）" required>
                                <el-col :span="10">
                                    <el-form-item
                                        prop="processPercentage.tailor.min"
                                        :rules="[
                                            { required: true, message: '请输入最小值', trigger: 'blur' },
                                        ]"
                                    >
                                        <el-input
                                            @blur="editForm.processPercentage.tailor.min=switchToFloat(editForm.processPercentage.tailor.min, 'unsigned');switchObjMaxAndMin(editForm.processPercentage.tailor)"
                                            v-model="editForm.processPercentage.tailor.min"
                                            placeholder="请输入最小值"
                                            :disabled="uneditable"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col class="gap-line" :span="1">-</el-col>
                                <el-col :span="10">
                                    <el-form-item
                                        prop="processPercentage.tailor.max"
                                        :rules="[
                                            { required: true, message: '请输入最大值', trigger: 'blur' },
                                        ]"
                                    >
                                        <el-input
                                            @blur="editForm.processPercentage.tailor.max=switchToFloat(editForm.processPercentage.tailor.max, 'unsigned');switchObjMaxAndMin(editForm.processPercentage.tailor)"
                                            v-model="editForm.processPercentage.tailor.max"
                                            placeholder="请输入最大值"
                                            :disabled="uneditable"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item class="c-form-item-inner" label="打版（小数）" required>
                                <el-col :span="10">
                                    <el-form-item
                                        prop="processPercentage.plateMaking.min"
                                        :rules="[
                                            { required: true, message: '请输入最小值', trigger: 'blur' },
                                        ]"
                                    >
                                        <el-input
                                            @blur="editForm.processPercentage.plateMaking.min=switchToFloat(editForm.processPercentage.plateMaking.min, 'unsigned');switchObjMaxAndMin(editForm.processPercentage.plateMaking)"
                                            v-model="editForm.processPercentage.plateMaking.min"
                                            placeholder="请输入最小值"
                                            :disabled="uneditable"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col class="gap-line" :span="1">-</el-col>
                                <el-col :span="10">
                                    <el-form-item
                                        prop="processPercentage.plateMaking.max"
                                        :rules="[
                                            { required: true, message: '请输入最大值', trigger: 'blur' },
                                        ]"
                                    >  
                                        <el-input
                                            @blur="editForm.processPercentage.plateMaking.max=switchToFloat(editForm.processPercentage.plateMaking.max, 'unsigned');switchObjMaxAndMin(editForm.processPercentage.plateMaking)"
                                            v-model="editForm.processPercentage.plateMaking.max"
                                            placeholder="请输入最大值"
                                            :disabled="uneditable"
                                        ></el-input> 
                                    </el-form-item>
                                </el-col>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item class="c-form-item-inner" label="缝制（小数）" required>
                                <el-col :span="10">
                                    <el-form-item
                                        prop="processPercentage.sewing.min"
                                        :rules="[
                                            { required: true, message: '请输入最小值', trigger: 'blur' },
                                        ]"
                                    >
                                        <el-input
                                            @blur="editForm.processPercentage.sewing.min=switchToFloat(editForm.processPercentage.sewing.min, 'unsigned');switchObjMaxAndMin(editForm.processPercentage.sewing)"
                                            v-model="editForm.processPercentage.sewing.min"
                                            placeholder="请输入最小值"
                                            :disabled="uneditable"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col class="gap-line" :span="1">-</el-col>
                                <el-col :span="10">
                                    <el-form-item
                                        prop="processPercentage.sewing.max"
                                        :rules="[
                                            { required: true, message: '请输入最大值', trigger: 'blur' },
                                        ]"
                                    >
                                        <el-input
                                            @blur="editForm.processPercentage.sewing.max=switchToFloat(editForm.processPercentage.sewing.max, 'unsigned');switchObjMaxAndMin(editForm.processPercentage.sewing)"
                                            v-model="editForm.processPercentage.sewing.max"
                                            placeholder="请输入最大值"
                                            :disabled="uneditable"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item class="c-form-item-inner" label="熨烫（小数）" required>
                                <el-col :span="10">
                                    <el-form-item
                                        prop="processPercentage.ironing.min"
                                        :rules="[
                                            { required: true, message: '请输入最小值', trigger: 'blur' },
                                        ]"
                                    >
                                        <el-input
                                            @blur="editForm.processPercentage.ironing.min=switchToFloat(editForm.processPercentage.ironing.min, 'unsigned');switchObjMaxAndMin(editForm.processPercentage.ironing)"
                                            v-model="editForm.processPercentage.ironing.min"
                                            placeholder="请输入最小值"
                                            :disabled="uneditable"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col class="gap-line" :span="1">-</el-col>
                                <el-col :span="10">
                                    <el-form-item
                                        prop="processPercentage.ironing.max"
                                        :rules="[
                                            { required: true, message: '请输入最大值', trigger: 'blur' },
                                        ]"
                                    >
                                        <el-input
                                            @blur="editForm.processPercentage.ironing.max=switchToFloat(editForm.processPercentage.ironing.max, 'unsigned');switchObjMaxAndMin(editForm.processPercentage.ironing)"
                                            v-model="editForm.processPercentage.ironing.max"
                                            placeholder="请输入最大值"
                                            :disabled="uneditable"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item class="c-form-item-inner" label="后道（小数）" required>
                                <el-col :span="10">
                                    <el-form-item
                                        prop="processPercentage.backEnd.min"
                                        :rules="[
                                            { required: true, message: '请输入最小值', trigger: 'blur' },
                                        ]"
                                    >
                                        <el-input
                                            @blur="editForm.processPercentage.backEnd.min=switchToFloat(editForm.processPercentage.backEnd.min, 'unsigned');switchObjMaxAndMin(editForm.processPercentage.backEnd)"
                                            v-model="editForm.processPercentage.backEnd.min"
                                            placeholder="请输入最小值"
                                            :disabled="uneditable"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col class="gap-line" :span="1">-</el-col>
                                <el-col :span="10">
                                    <el-form-item
                                        prop="processPercentage.backEnd.max"
                                        :rules="[
                                            { required: true, message: '请输入最大值', trigger: 'blur' },
                                        ]"
                                    >
                                        <el-input
                                            @blur="editForm.processPercentage.backEnd.max=switchToFloat(editForm.processPercentage.backEnd.max, 'unsigned');switchObjMaxAndMin(editForm.processPercentage.backEnd)"
                                            v-model="editForm.processPercentage.backEnd.max"
                                            placeholder="请输入最大值"
                                            :disabled="uneditable"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item class="c-form-item" label="当月累计接单数量">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/012.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/012.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        当月累计接单数量 = 最小值和最大值之间的数， 该数值有规律递增
                    </p>
                    <el-form-item class="c-form-item-inner" label="接单数范围（整数）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthOrderNumber.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthOrderNumber.min=switchToInt(editForm.monthOrderNumber.min, 'unsigned');switchObjMaxAndMin(editForm.monthOrderNumber)"
                                    v-model="editForm.monthOrderNumber.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthOrderNumber.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthOrderNumber.max=switchToInt(editForm.monthOrderNumber.max, 'unsigned');switchObjMaxAndMin(editForm.monthOrderNumber)"
                                    v-model="editForm.monthOrderNumber.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="当月完成件数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/013.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/013.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        当月完成件数 = 最小值和最大值之间的数， 该数值有规律递增
                    </p>
                    <el-form-item class="c-form-item-inner" label="完成件数范围（整数）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthCompleteNumber.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthCompleteNumber.min=switchToInt(editForm.monthCompleteNumber.min, 'unsigned');switchObjMaxAndMin(editForm.monthCompleteNumber)"
                                    v-model="editForm.monthCompleteNumber.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthCompleteNumber.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthCompleteNumber.max=switchToInt(editForm.monthCompleteNumber.max, 'unsigned');switchObjMaxAndMin(editForm.monthCompleteNumber)"
                                    v-model="editForm.monthCompleteNumber.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="平均订单生产周期">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/014.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/014.png">
                        </div>
                    </el-popover>
                    <el-form-item class="c-form-item-inner" label="配置数据（天数，小数）"
                        prop="averageOrderProductPeriod.radix"
                        :rules="[
                            { required: true, message: '请输入配置数据', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.averageOrderProductPeriod.radix=switchToFloat(editForm.averageOrderProductPeriod.radix, 'unsigned')"
                            class="w"
                            v-model="editForm.averageOrderProductPeriod.radix"
                            placeholder="请输入配置数据"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="衣加加订单">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/015.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/015.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       衣加加各类目订单数 = 最大值和最小值之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.yjjOrder" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'yjjOrder.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入类目名称', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">类目名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'yjjOrder.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min = switchToInt(item.min, 'unsigned'); switchMaxAndMin(editForm.yjjOrder, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'yjjOrder.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max = switchToInt(item.max, 'unsigned'); switchMaxAndMin(editForm.yjjOrder, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.yjjOrder.length === 1}" 
                                    :title="editForm.yjjOrder.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('yjjOrder', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('yjjOrder', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="生产订单">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/016.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/016.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        抓取衣加加生产订单数据
                    </p>
                    <el-form-item class="c-form-item-inner" label="输出行数（整数）"
                        prop="averageOrderProductPeriod.radix"
                        :rules="[
                            { required: true, message: '请输入配置数据', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.productionOrder.lineNumber=switchToInt(editForm.productionOrder.lineNumber, 'unsigned')"
                            class="w"
                            v-model="editForm.productionOrder.lineNumber"
                            placeholder="请输入输出行数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>


                
                <el-form-item class="c-form-item" label="E+工厂产能">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-eplus/017.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-eplus/017.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        工厂产能（%） = 最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="产能范围（正整数）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="factoryCapacity.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.factoryCapacity.min=switchToInt(editForm.factoryCapacity.min, 'unsigned'); switchObjMaxAndMin(editForm.factoryCapacity)"
                                    v-model="editForm.factoryCapacity.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="factoryCapacity.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.factoryCapacity.max=switchToInt(editForm.factoryCapacity.max, 'unsigned'); switchObjMaxAndMin(editForm.factoryCapacity)"
                                    v-model="editForm.factoryCapacity.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

            </el-form>
            <div class="bottom-btns-wrap" v-if="!uneditable">
                <el-button class="btn-cancel" @click="cancelEdit">取消</el-button>
                <el-button class="btn-large" type="primary" @click="submitHandle">提交</el-button>
            </div>
        </div>
        
        
    </div>
</template>

<script>
import {ajaxDatav} from '../../common/request_datav.js'
export default {
    data() {
        return {
            uneditable: true,
            editForm: {
                // 工厂人数
                factoryStaffNumer: {
                    min: '', // 最小值
                    max: ''  // 最大值
                },

                // 出勤人数 
                attendanceStaffNumber: {
                    min: '', // 最小值
                    max: ''  // 最大值
                },

                // 工厂面积
                factoryArea: {
                    radix: '' // 配置数据
                },

                // 设备数量
                equipmentNumber: {
                    radix: '' // 配置数据
                },

                // 工厂数量
                factoryNumber: {
                    radix: '' // 配置数据
                },

                // 工厂明细
                factoryDetails: [
                    {
                        key: 1,
                        name: '',  // 企业名称
                        radix: '', // 静态数据
                    }
                ],

                // 今日成衣加工件数
                todayClothesProcessing: {
                    startTime: '', // 起始时间 (时) 24小时制
                    endTime: '',   // 结束时间
                    min: '',   // 最小值
                    max: '',   // 最大值 
                },

                // 今日完成订单数
                todayFinishedOrder: {
                    startTime: '', // 起始时间 (时) 24小时制
                    endTime: '',   // 结束时间
                    min: '',   // 最小值
                    max: '',   // 最大值 
                },

                // 综合体订单覆盖率
                zhtOrdercoverageRate: {
                    radix: '',  // 配置数据，小数
                },

                // 合格率
                passRate: [
                    {
                        key: 1,
                        name: '', // 工序名称
                        min: '',  // 配置最小值
                        max: '',  // 配置最大值
                    }
                ],

                // 工序占比
                processPercentage: {
                    tailor: {     // 裁剪
                        min: '',  // 配置最小值
                        max: '',  // 配置最大值
                    },
                    plateMaking: { // 打版
                        min: '',  
                        max: '',  
                    },
                    sewing: {   // 缝制
                        min: '', 
                        max: '',  
                    }, 
                    ironing: { // 熨烫
                        min: '',  
                        max: '',  
                    },
                    backEnd: { // 后道
                        min: '',  
                        max: '',  
                    }
                },

                // 当月累计接单数量
                monthOrderNumber: {
                    min: '',  // 配置最小值
                    max: '',  // 配置最大值
                },

                // 当月完成件数 
                monthCompleteNumber: {
                    min: '',  // 配置最小值
                    max: '',  // 配置最大值
                },

                // 平均订单生产周期
                averageOrderProductPeriod: {
                    radix: '', // 配置数据 （天）
                },

                // 衣加加订单
                yjjOrder: [
                    {
                        key: 1,
                        name: '', // 类目
                        min: '',  // 最小值
                        max: ''   // 最大值
                    }
                ],

                // 生产订单
                productionOrder: {
                    lineNumber: '', // 输出行数
                },

                // E+工厂产能
                factoryCapacity: {
                    min: '', // 配置最大值
                    max: '', // 配置最小值
                }
            }
        }
    },
    created() {
        this.getData();
    },
    methods: {
        // 编辑操作
        editHandle() {
            this.uneditable = false
        },
        // 取消编辑
        cancelEdit() {
            this.$confirm('确认取消编辑吗?', '提示', {
                confirmButtonText: '取消编辑',
                cancelButtonText: '继续编辑',
                type: 'warning'
            }).then(() => {
                this.uneditable = true
                this.$refs['editForm'].clearValidate()
                this.getData();
            })
        },
        // 跳转外部链接
        linkToDataV() {
            window.open('https://datav.aliyuncs.com/share/868f95f4d518d8d8623eec47135b522d')
        },
        // 立即生效
        takeEffectAtOnce() {
            this.$confirm('数据配置默认第二天零点生效，若需立即生效，可使用本功能。本功能将立即刷新数据到大屏，有可能造成当日数据前后不一致。请谨慎使用。', '提示', {
                confirmButtonText: '立即生效',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                console.log('立即生效')
                ajaxDatav.post('/data-statistics/refreshByNumber', {
                    number: 3
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success('提交成功，配置的数据会立即生效到大屏！');
                    } else {
                        this.$message.error(res.msg)
                    }
                }).catch(e => {
                    console.error(e)
                })

            }).catch(err=> {
                console.log(err)
            })
        },
        // 回到顶部
        toPageTop() {
            document.querySelector('#mainBox').scrollTop = 0;
        },
        // 删除一行
        removeLine(key, index) {
            let length = this.editForm[key].length
            if (length <= 1) return
            this.editForm[key].splice(index, 1)
        },
        // 添加一行
        addLine(key, index) {
            let d = Date.now()
            let item
            if (key == 'factoryDetails') {
                item = {
                    key: d,
                    name: '',
                    radix: ''
                }
            }
            if (key == 'passRate' || key == 'yjjOrder') {
                item = {
                    key: d,
                    name: '',
                    min: '',
                    max: ''
                }
            }
            this.editForm[key].splice(index+1, 0, item)
        },
        // 转化为整数
        switchToInt(value, type) {
            let v = parseInt(value)
            if (isNaN(v)) return ''
            return type === 'unsigned' ? Math.abs(v) : v
        },
        // 转化为浮点数
        switchToFloat(value, type) {
            let v = parseFloat(value)
            if (isNaN(v)) return ''
            return type === 'unsigned' ? Math.abs(v) : v
        },
        // 获取数据
        getData() {
            ajaxDatav.get('/data-setting/getByNumber', {
                number: 3
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    if (res.data && res.data.content) {
                        try {
                            let content = JSON.parse(res.data.content);
                            this.editForm = {
                                ...this.editForm,
                                ...content
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(e => {
                console.error(e);
            })
        },
        // 提交表单
        submitHandle() {
            console.log('submit');
            // console.log(this.editForm);
            // console.log(JSON.stringify(this.editForm));

            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: '正在提交数据...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    ajaxDatav.post('/data-setting/save', {
                        content: JSON.stringify(this.editForm),
                        number: 3
                    }).then(res => {
                        if (res.code == 200) {
                            this.$message.success('提交成功');
                            this.uneditable = true
                            this.getData();
                        } else {
                            this.$message.error(res.msg)
                        }
                    }).catch(e => {
                        console.error(e)
                    }).finally(() => {
                        loading.close();
                    })
                } else {
                    this.$message.error('校验不通过，请检查表单')
                }
            })
        },
        // 自动切换对象中最大值和最小值
        switchObjMaxAndMin(obj, min='min', max='max') {
            if (obj[min] === '' || obj[max] === '') return
            if (obj[min] > obj[max]) {
                let middle = obj[min]
                obj[min] = obj[max]
                obj[max] = middle
            }
        },
        // 自动切换列表中最大值和最小值
        switchMaxAndMin(list, index, min='min', max='max') {
            if (list[index][min] === '' || list[index][max] === '') return
            if (list[index][min] > list[index][max]) {
                let middle = list[index][min]
                list[index][min] = list[index][max]
                list[index][max] = middle
            }
        }
    }
}
</script>

<style scoped lang="scss">
.page-wrapper {
    background: #fff;
    padding-bottom: 80px;
    min-height: 100px;
    .tit {
        margin: 0;
        padding: 24px;
        font-size: 20px;
        color: #111;
        font-weight: normal;
    }
    .top-btns {
        position: fixed;
        top: 40%;
        right: 32px;
        z-index: 100;
        .r-btn {
            margin-top: 6px;
        }
    } 
    .datav-form-wrapper {
        width: 900px;
        padding: 0 24px;
        .w {
            width: 400px;
        }
        .w2 {
            width: 200px;
        }
        .info {
            font-size: 13px;
            color: #888;
            line-height: 1.5;
        }
    }
    .c-row-wrap {
        padding: 8px 0;
    }
    .c-sort-num {
        margin-top: 12px;
        display: block;
        width: 20px;
        height: 20px;
        border: 1px solid #999;
        line-height: 20px;
        text-align: center;
        color: #999;
        font-size: 12px;
        border-radius: 50%;
    }
    .c-remove {
        margin-right: 4px;
        cursor: pointer;
        font-size: 16px;
        &.disabled {
            color: #ccc;
            cursor: no-drop;
        }
    }
    .c-add {
        font-size: 16px;
        cursor: pointer;
    }
    .bottom-btns-wrap {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 20px 0 20px 0px;
        text-align: center;
        z-index: 1;
        background: #fff;
        box-shadow: 0 -2px 10px #ccc;
        .btn-large {
            padding: 14px 120px;
        }
        .btn-cancel {
            padding-top: 14px;
            padding-bottom: 14px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/datav/factory-eplus.vue